import React from 'react';
import { AuthContext } from './authProvider';

let useUser = () => {
  let auth = React.useContext(AuthContext);
  return auth?.user;
};

export default useUser;
